import React from 'react'
export default function TestWatermarkPage() {
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [preview, setPreview] = React.useState(null);
    const [resultImage, setResultImage] = React.useState(null);
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Basic client-side validation
            if (file.size > 10 * 1024 * 1024) {
                setError('File is too large. Maximum size is 10MB.');
                return;
            }
            if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
                setError('Invalid file type. Please upload a JPG, PNG, or WEBP.');
                return;
            }

            setSelectedFile(file);
            setPreview(URL.createObjectURL(file));
            setResultImage(null);
            setError(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedFile) {
            setError('Please select an image file first.');
            return;
        }

        setIsProcessing(true);
        setError(null);
        setResultImage(null);

        const formData = new FormData();
        formData.append('image_file', selectedFile);

        try {
            const response = await fetch('/api/test_watermark_process.php', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || 'An unknown error occurred during processing.');
            }

            if (result.success) {
                // Add a timestamp to the URL to force the browser to reload the image and not use a cached version
                setResultImage(result.filePath + '?t=' + new Date().getTime());
            } else {
                throw new Error(result.error || 'Processing failed on the server.');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div className="container mx-auto p-8">
            <div className="bg-white rounded-xl shadow-lg p-8 max-w-3xl mx-auto">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">Image Processor Test</h1>
                <p className="text-gray-600 mb-6">Test the remove.bg and watermarking workflow.</p>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="image-upload" className="block text-sm font-medium text-gray-700 mb-2">Upload Product Image (JPG, PNG, WEBP - Max 10MB)</label>
                        <input id="image-upload" type="file" onChange={handleFileChange} accept="image/jpeg,image/png,image/webp" className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"/>
                    </div>

                    {preview && <img src={preview} alt="Preview" className="mt-4 rounded-lg shadow-md max-h-60 mx-auto" />}

                    <button type="submit" disabled={isProcessing || !selectedFile} className="w-full primary-gradient text-white font-bold py-3 px-4 rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 flex items-center justify-center">
                        {isProcessing ? <><i className="fas fa-spinner fa-spin mr-2"></i>Processing Image...</> : 'Process Image'}
                    </button>
                </form>

                <div className="mt-8">
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">Result:</h2>
                    {error && <div className="bg-red-100 text-red-700 p-4 rounded-lg">{error}</div>}
                    {isProcessing && <div className="text-center p-4"><i className="fas fa-cog fa-spin text-3xl text-blue-500"></i><p className="mt-2 text-gray-600">Please wait...</p></div>}
                    {resultImage && (
                        <div className="text-center p-4 bg-gray-100 rounded-lg">
                            <img src={resultImage} alt="Processed result" className="max-w-full max-h-96 mx-auto rounded-lg shadow-lg" />
                            <p className="text-sm text-gray-500 mt-2">Final image with background removed and watermark applied.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
